import AnimationTable from "#common/AnimationTabla"
import { Box, Stack } from "@mui/material"
import { ChangeTitle } from "Components/menu/funciones"
import { useParams } from "react-router-dom"

const TablaDetalle = ({ title = "", nameParam = "", ruta = "", tabla, Detalle }) => {
	ChangeTitle(title)
	const params = useParams()
	const param = params[nameParam]
	// const navigate = useNavigate()
	return (
		<Box display="flex" width="100%" flexDirection={"column"}>
			{/* <Paper
				sx={{
					display: "flex",
					flexDirection: "column",
					padding: 1,
					width: "100%",
				}}
			> */}
			<AnimationTable activar={!param}>{tabla}</AnimationTable>

			<AnimationTable activar={param}>
				<Box
					sx={{
						width: "100%",
						maxHeight: "91vh", // igual que el padre para evitar overflow
						overflowY: "auto", // aquí activas el scroll
						pr: 3, // opcional: padding para evitar que tape el scrollbar
					}}
				>
					<Stack spacing={2} padding={2}>
						{/* <div>
							<Button
								variant="text"
								size="small"
								onClick={() => navigate(ruta)}
								startIcon={<ArrowBackIcon />}
							>
								Regresar
							</Button>
						</div> */}
						<Detalle {...{ [nameParam]: param }} />
					</Stack>
				</Box>
			</AnimationTable>
			{/* </Paper> */}
		</Box>
	)
}

export default TablaDetalle
